/**
 * Notification Types for Thai Security Directory
 * In-App Notification System
 */

export enum NotificationEventType {
  // Company-related notifications
  COMPANY_PENDING = 'COMPANY_PENDING',
  COMPANY_APPROVED = 'COMPANY_APPROVED',
  COMPANY_REJECTED = 'COMPANY_REJECTED',

  // Update-related notifications
  UPDATE_PENDING = 'UPDATE_PENDING',
  UPDATE_APPROVED = 'UPDATE_APPROVED',
  UPDATE_REJECTED = 'UPDATE_REJECTED',

  // Claim-related notifications (Company Ownership)
  CLAIM_PENDING = 'CLAIM_PENDING',
  CLAIM_SUBMITTED = 'CLAIM_SUBMITTED',
  CLAIM_APPROVED = 'CLAIM_APPROVED',
  CLAIM_REJECTED = 'CLAIM_REJECTED',

  // User-related notifications
  NEW_MEMBER = 'NEW_MEMBER',

  // Contact-related notifications
  CONTACT_FORM = 'CONTACT_FORM',

  // System notifications
  SYSTEM = 'SYSTEM'
}

export interface Notification {
  id: string
  user_id: string
  type: NotificationEventType
  title: string
  message: string
  link: string | null
  is_read: boolean
  read_at: string | null
  extra_data: Record<string, any> | null
  created_at: string
  relative_time: string // จาก backend response (e.g., "5 นาทีที่แล้ว")
}

export interface NotificationsResponse {
  notifications: Notification[]
  total: number
  page: number
  per_page: number
  total_pages: number
}

export interface UnreadCountResponse {
  unread_count: number
}

export interface NotificationActionResponse {
  success: boolean
  message: string
}

// Helper type for notification icon mapping
export type NotificationIconType = 'company' | 'approve' | 'reject' | 'update' | 'member' | 'system'

// Helper function to get notification icon type
export const getNotificationIconType = (type: NotificationEventType): NotificationIconType => {
  switch (type) {
    case NotificationEventType.COMPANY_PENDING:
    case NotificationEventType.UPDATE_PENDING:
    case NotificationEventType.CLAIM_PENDING:
      return 'company'
    case NotificationEventType.COMPANY_APPROVED:
    case NotificationEventType.UPDATE_APPROVED:
    case NotificationEventType.CLAIM_APPROVED:
      return 'approve'
    case NotificationEventType.COMPANY_REJECTED:
    case NotificationEventType.UPDATE_REJECTED:
    case NotificationEventType.CLAIM_REJECTED:
      return 'reject'
    case NotificationEventType.CLAIM_SUBMITTED:
      return 'update'
    case NotificationEventType.CONTACT_FORM:
      return 'member'
    case NotificationEventType.NEW_MEMBER:
      return 'member'
    case NotificationEventType.SYSTEM:
    default:
      return 'system'
  }
}

// Helper function to get notification color scheme
export const getNotificationColor = (type: NotificationEventType): string => {
  switch (type) {
    case NotificationEventType.COMPANY_APPROVED:
    case NotificationEventType.UPDATE_APPROVED:
    case NotificationEventType.CLAIM_APPROVED:
      return 'green'
    case NotificationEventType.COMPANY_REJECTED:
    case NotificationEventType.UPDATE_REJECTED:
    case NotificationEventType.CLAIM_REJECTED:
      return 'red'
    case NotificationEventType.COMPANY_PENDING:
    case NotificationEventType.UPDATE_PENDING:
    case NotificationEventType.CLAIM_PENDING:
      return 'yellow'
    case NotificationEventType.CLAIM_SUBMITTED:
      return 'blue'
    case NotificationEventType.CONTACT_FORM:
      return 'blue'
    case NotificationEventType.NEW_MEMBER:
      return 'blue'
    case NotificationEventType.SYSTEM:
    default:
      return 'gray'
  }
}
